module.exports = __webpack_public_path__ + "img/left-s.69986ca4.png";